import { render } from "./RequestFacultyCourseLoadDialog.vue?vue&type=template&id=44a777c4"
import script from "./RequestFacultyCourseLoadDialog.vue?vue&type=script&lang=js"
export * from "./RequestFacultyCourseLoadDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__